// External Dependencies:
import React from 'react'
import { connect } from 'react-redux'

class Colleges extends React.Component {
	render() {
		const { page } = this.props

		return (
			<div className="colleges-image-links">
				<div className="image-links-wrap">
					<div className="image-links">
						<div className="image-link-wrap">
							<a href="http://mamarapha.adventist.edu.au/" className="image-link" target="_blank" rel="noopener">
								<div className="-inner">
									<div className="-image">
										<img src={ `${siteData.images_url}colleges/Mamarapha.jpg` } alt="" />
									</div>
								</div>
							</a>
						</div>

						<div className="image-link-wrap">
							<a href="http://www.karalundi.wa.edu.au/" className="image-link" target="_blank" rel="noopener">
								<div className="-inner">
									<div className="-image">
										<img src={ `${siteData.images_url}colleges/Karalundi.png` } alt="" />
									</div>
								</div>
							</a>
						</div>
					</div>
				</div>
			</div>
		)
	}
}

const mapStateToProps = ( state, ownProps ) => {
	return {
		page: state.page.selected
	}
}

const mapDispatchToProps = ( dispatch, ownProps ) => {
	return {

	}
}

export default connect( mapStateToProps, mapDispatchToProps )( Colleges )



// WEBPACK FOOTER //
// ./views/page/Colleges.jsx